/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostingactionneeded2Inputs */

const en_crosspostingactionneeded2 = /** @type {(inputs: Crosspostingactionneeded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Action needed`)
};

const de_crosspostingactionneeded2 = /** @type {(inputs: Crosspostingactionneeded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktion erforderlich`)
};

/**
* | output |
* | --- |
* | "Action needed" |
*
* @param {Crosspostingactionneeded2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostingactionneeded2 = /** @type {((inputs?: Crosspostingactionneeded2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostingactionneeded2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostingactionneeded2(inputs)
	return de_crosspostingactionneeded2(inputs)
});
export { crosspostingactionneeded2 as "crosspostingActionNeeded" }